import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { ScrollToTop } from './components/ScrollToTop';
import { Landing } from './views/Landing/Landing';
import { PrivacyPolicy } from './views/Legal/PrivacyPolicy';
import { Terms } from './views/Legal/Terms';
import { Support } from './views/Support/Support';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
